<div class="table-actions-container">
  <div class="search-wrapper">
    <app-search-field
      class="resource-search-form"
      id="org-search"
      [searchTerm]="searchTerm"
      [isLiveSearch]="isLiveSearch"
      (doSearch)="onSearch($event)"
    ></app-search-field>
  </div>
  @if (Utils.hasFeatureFlag(Const.FEATURE_ADVANCED_SEARCH)) {
    <div class="advanced-search-btn">
      @if (!advancedSearchOpen) {
        <button
          fd-button
          class="link-color"
          (click)="openAdvancedSearch()"
          [disabled]="!advancedSearchReady"
          [title]="advancedSearchReady ? 'Display advanced search fields' : 'Loading available resource types...'"
        >Advanced Search</button>
      }
      @if (advancedSearchOpen) {
        <button
          fd-button
          class="link-color"
          (click)="openAdvancedSearch()"
          title="Close advanced search and return to current location"
        >Close Advanced Search</button>
      }
    </div>
  }

  <fd-toolbar-spacer></fd-toolbar-spacer>
  @if (showCreateMenu) {
    <div class="menu-wrapper">
      <fd-busy-indicator [loading]="!loadingFinished" size="m">
        <button
          fd-button
          fdType="emphasized"
          id="create-resource"
          [fdMenuTrigger]="menu"
        >
          <app-icon icon="plus" size="1x"></app-icon>
          <span>{{ "New" | uppercase }}</span>
          <app-icon icon="angle-down" size="1x"></app-icon>
        </button>
      </fd-busy-indicator>
      <fd-menu #menu id="table-actions-fd-menu-id">
        @if (showCreateFolder) {
          <li fd-menu-item style="margin-top: 0.1rem">
            <a
              fd-menu-interactive
              id="menu-create-folder-btn"
              (click)="onCreateItem(ResourceType.FOLDER)"
            >
              <app-icon [icon]="folderGlyph" size="1x" class="icon"></app-icon>
              <span fd-menu-title>Folder</span>
            </a>
          </li>
        }
        @if (showCreateResourceGroup) {
          <li fd-menu-item>
            <a
              fd-menu-interactive
              id="menu-create-resource-group-btn"
              (click)="onCreateItem(ResourceType.RESOURCE_GROUP)"
            >
              <app-icon
                [icon]="resourceGroupGlyph"
                size="1x"
                class="icon"
              ></app-icon>
              <span fd-menu-title>Resource Group</span>
            </a>
          </li>
        }
        @if (
          this.subSystemResourcesByGroup &&
          this.subSystemResourcesByGroup.length > 0 &&
          (showCreateResourceGroup || showCreateFolder)
        ) {
          <div class="border-line"></div>
        }
        @for (
          service of this.subSystemResourcesByGroup | sortBy: true : "type";
          track service
        ) {
          <li fd-menu-item>
            @if (service.group) {
              <a
                fd-menu-interactive
                class="menu-create-resource-btn service-{{ service.type }}"
                [title]="service.type"
                (click)="onCreateServiceInstance(service)"
              >
                <app-icon
                  [icon]="service.type | resourceGlyph"
                  size="1x"
                  class="icon"
                ></app-icon>
                <span fd-menu-title>{{
                  service.displayName || service.type
                }}</span>
              </a>
            }
            @if (!service.group) {
              <a
                fd-menu-interactive
                class="disabled menu-create-resource-btn {{ service.type }}"
                [title]="service.type"
              >
                <fd-menu-addon position="before">
                  <app-icon
                    [icon]="service.type | resourceGlyph"
                    size="1x"
                  ></app-icon>
                </fd-menu-addon>
                <span fd-menu-title>{{
                  service.displayName || service.type
                }}</span>
              </a>
            }
          </li>
        }
        @if (showCreateServiceInstance) {
          <div class="border-line"></div>
        }
        @if (showCreateServiceInstance) {
          <li fd-menu-item>
            <a
              fd-menu-interactive
              id="menu-create-service-instance-btn"
              (click)="onCreateServiceInstance()"
            >
              <app-icon icon="puzzle-piece" size="1x" class="icon"></app-icon>
              <span fd-menu-title>Resource</span>
            </a>
          </li>
        }
        @if (showCreateYAML) {
          <div class="border-line"></div>
        }
        @if (showCreateYAML) {
          <li fd-menu-item>
            <a
              fd-menu-interactive
              id="create-with-yaml-link"
              (click)="onCreateGenericResource()"
            >
              <app-icon
                [icon]="ResourceType.YAML | resourceGlyph"
                size="1x"
                class="icon"
              ></app-icon>
              <span fd-menu-title>Create with YAML</span>
            </a>
          </li>
        }
      </fd-menu>
      @if (!Utils.isPrivateCloud && showCreateApplication) {
        <fd-busy-indicator
          class="new-button-wrapper"
          [loading]="!loadingFinished"
          size="m"
        >
          <button
            fd-button
            fdType="emphasized"
            id="quick-start-button"
            [fdMenuTrigger]="quickStartMenu"
          >
            <span>{{ "Quick Start" | uppercase }}</span>
            <app-icon icon="angle-down" size="1x"></app-icon>
          </button>
        </fd-busy-indicator>
      }
      <fd-menu #quickStartMenu>
        <li
          id="setUpAppBtn"
          fd-menu-item
          [style.display]="showCreateApplication ? 'block' : 'none'"
          [title]="createAppDisabledTooltip()"
        >
          <a
            fd-menu-interactive
            [class.disabled]="isCreateApplicationDisabled()"
            (click)="onCreateApplication(WizardApplicationType.UNIFIED)"
          >
            <app-icon icon="layer-group" size="1x" class="icon"></app-icon>
            <span
              fd-menu-title
              i18n="
                XMIT|Unified Wizard menu
                entry@@shared.table-actions.unifiedWizardMenuEntry"
            >
              Set Up App
            </span>
          </a>
        </li>
        <li
          fd-menu-item
          [style.display]="showCreateApplication ? 'block' : 'none'"
          [title]="createSuiteDisabledTooltip()"
        >
          <a
            fd-menu-interactive
            [class.disabled]="
              isCreateApplicationDisabled() || isCreateSuiteDisabled()
            "
            (click)="onCreateApplication(WizardApplicationType.SUITE)"
          >
            <fd-icon class="icon" glyph="overview-chart"></fd-icon>
            <span
              fd-menu-title
              i18n="
                XMIT|Suite Unified Wizard menu
                entry@@shared.table-actions.unifiedSuiteWizardMenuEntry"
            >
              Set Up Product Blueprint
            </span>
          </a>
        </li>
      </fd-menu>
    </div>
  }
</div>
